// src/components/shared/TaxYearNotice.tsx
// הערת שנת המס — פסקה אחת, כחול מודגש 12px, הילד הראשון של אזור התוצאות.
//
// חובה להציב את הרכיב *בתוך* ה-div של ref={printRef} (וכילד ישיר שלו, לא בתוך
// כרטיס): מסמך ההדפסה משכפל את ה-DOM הזה, ובדף ההיסטוריה הוא מוחק את הכרטיס
// הראשון. ה-iframe של ההדפסה ממפה בעצמו את text-blue-700 / font-bold / text-xs.

import React from "react";
import { TAX_YEAR_NOTICE } from "../../config/taxYearNotice";

interface TaxYearNoticeProps {
  /** טקסט חלופי (snapshot של חישוב שמור). ברירת מחדל: הנוסח הנוכחי. ריק = לא מוצג */
  text?: string;
}

const TaxYearNotice: React.FC<TaxYearNoticeProps> = ({ text = TAX_YEAR_NOTICE }) => {
  if (!text) return null;
  return (
    <p role="note" className="tax-year-notice text-xs font-bold text-blue-700">
      {text}
    </p>
  );
};

export default TaxYearNotice;
